import api from '@/api/index.js'

const account_association = {
  state: {
    loading: false,
    updating: false,
    data: null,
    error: null,
  },

  mutations: {
    SET_ACCOUNT_ASSOCIATION_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_ASSOCIATION_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_ACCOUNT_ASSOCIATION: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_ASSOCIATION_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
  },

  actions: {
    LoadAccountAssociation({commit}, req) {
      commit('SET_ACCOUNT_ASSOCIATION_LOADING', true)
      commit('SET_ACCOUNT_ASSOCIATION_ERROR', null)
      return api.get(`accounts/${req.accountId}/associations/${req.associationId}/${req.type}`)
        .then((response) => {
          commit('SET_ACCOUNT_ASSOCIATION', response)
          commit('SET_ACCOUNT_ASSOCIATION_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_ASSOCIATION_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  },
}

export default account_association
